import React from 'react';
import clsx from 'clsx';
import * as NavigationSelectors from '../../../../redux/reducers/gl_navigation_reducer/selectors';
import useStyles from '../styles';
import { Routes } from '../../../config/Routes';

export default function SidebarContent() {
  // console.log('Render SidebarContent');

  const classes = useStyles();
  const open = NavigationSelectors.useSidebarIsVisible();
  // const isMobileScreen = NavigationSelectors.isMobileScreen();

  return (
    <React.Fragment>
      <div
        className={clsx(classes.content, {
          [classes.contentShift]: open, //!isMobileScreen &&
        })}
      >
        <div className={classes.drawerHeader} />
        <RoutesWrapper />
      </div>
    </React.Fragment>
  );
}

const RoutesWrapper = React.memo(() => {
  return <Routes />;
});
